import { createAction } from 'redux-actions';
import { createRequestAction } from 'redux-flight-control';

import {
  DECODE_AUTH_TOKEN,
  REFRESH_AUTH_TOKEN,
  LOGIN_SUCCESS,
  LOGOUT,
  TICKET_VALIDATION_FAILURE,
  VALIDATE_SSO_TICKET,
} from '../constants';

import {
  decodeAuthToken as decodeTokenApi,
  refreshAuthToken as refreshTokenApi,
  validateSSOTicket,
} from '../api';

export const decodeAuthToken = createRequestAction(DECODE_AUTH_TOKEN, decodeTokenApi);
export const refreshAuthToken = createRequestAction(REFRESH_AUTH_TOKEN, refreshTokenApi);
export const loginSuccess = createAction(LOGIN_SUCCESS);
export const logout = createAction(LOGOUT);
export const ticketValidationFailure = createAction(TICKET_VALIDATION_FAILURE);
export const validateSsoTicket = createRequestAction(VALIDATE_SSO_TICKET, validateSSOTicket);



// WEBPACK FOOTER //
// ./features/authentication/redux/actions.js